<!-- 基本组件 公司组件 产品组件 -->
<template>
    <div>
        <div class="card">
            <div class="flex-sb">
                <span class="title">基础组件</span>
                <Icon type="ios-arrow-up" size="20" color="#484E66" />
            </div>
            <div class="flex-sb flex-w">
                <div class="card-btn" @click="menuClick(1)">
                    <img class="mr-12" src="@/assets/diy/image.png" />
                    <div>图文导航</div>
                </div>
                <div class="card-btn" @click="menuClick(2)">
                    <img class="mr-12" src="@/assets/diy/carousel.png" />
                    <div>轮播广告</div>
                </div>
                <div class="card-btn" @click="menuClick(3)">
                    <img class="mr-12" src="@/assets/diy/notice.png" />
                    <div>公告</div>
                </div>
                <div class="card-btn" @click="menuClick(4)">
                    <img class="mr-12" src="@/assets/diy/title.png" />
                    <div>标题</div>
                </div>
                <div class="card-btn" @click="menuClick(5)">
                    <img
                        class="mr-12"
                        src="@/assets/diy/display-advertising.png"
                    />
                    <div>图片广告</div>
                </div>
                <div class="card-btn" @click="menuClick(6)">
                    <img class="mr-12" src="@/assets/diy/video.png" />
                    <div>视频</div>
                </div>
                <div class="card-btn" @click="menuClick(7)">
                    <img class="mr-12" src="@/assets/diy/article-list.png" />
                    <div>文章列表</div>
                </div>
                <div class="card-btn" @click="menuClick(8)">
                    <img class="mr-12" src="@/assets/diy/image-text.png" />
                    <div>图文详情</div>
                </div>
                <div class="card-btn" @click="getPop">
                    <img class="mr-12" src="@/assets/diy/popup.png" />
                    <div>弹窗组件</div>
                </div>
            </div>
        </div>
        <div class="card">
            <div class="flex-sb">
                <span class="title">公司组件</span>
                <Icon type="ios-arrow-up" size="20" color="#484E66" />
            </div>
            <div class="flex-sb flex-w">
                <div class="card-btn" @click="menuClick(9)">
                    <img class="mr-12" src="@/assets/diy/image.png" />
                    <div>营业执照</div>
                </div>
                <div class="card-btn" @click="menuClick(10)">
                    <img class="mr-12" src="@/assets/diy/other.png" />
                    <div>其他资质</div>
                </div>
                <div class="card-btn" @click="menuClick(11)">
                    <img class="mr-12" src="@/assets/diy/picture.png" />
                    <div>公司图片</div>
                </div>
                <div class="card-btn" @click="menuClick(12)">
                    <img class="mr-12" src="@/assets/diy/notice.png" />
                    <div>公司信息</div>
                </div>
                <div class="card-btn" v-if="diy_id == 1" @click="menuClick(20)">
                    <img class="mr-12" src="@/assets/diy/agent.png" />
                    <div>代理商信息</div>
                </div>
            </div>
        </div>
        <div class="card" v-if="diy_id == 1">
            <div class="flex-sb">
                <span class="title">产品组件</span>
                <Icon type="ios-arrow-up" size="20" color="#484E66" />
            </div>
            <div class="flex-sb flex-w">
                <div class="card-btn" @click="menuClick(13)">
                    <img class="mr-12" src="@/assets/diy/attribute.png" />
                    <div>产品属性</div>
                </div>
                <div class="card-btn" @click="menuClick(14)">
                    <img class="mr-12" src="@/assets/diy/brochure.png" />
                    <div>产品样册</div>
                </div>
                <div class="card-btn" @click="menuClick(15)">
                    <img class="mr-12" src="@/assets/diy/report.png" />
                    <div>质检报告</div>
                </div>
                <div class="card-btn" @click="menuClick(16)">
                    <img class="mr-12" src="@/assets/diy/node.png" />
                    <div>实例节点</div>
                </div>
                <div class="card-btn" @click="menuClick(17)">
                    <img class="mr-12" src="@/assets/diy/result.png" />
                    <div>查询结果</div>
                </div>
                <div class="card-btn" @click="menuClick(18)">
                    <img class="mr-12" src="@/assets/diy/product-info.png" />
                    <div>产品信息</div>
                </div>
                <div class="card-btn" @click="menuClick(19)">
                    <img class="mr-12" src="@/assets/diy/product-img.png" />
                    <div>产品图片</div>
                </div>
            </div>
        </div>
        <div class="card mb-0" v-if="diy_id == 1">
            <div class="flex-sb">
                <span class="title">其他组件</span>
                <Icon type="ios-arrow-up" size="20" color="#484E66" />
            </div>
            <div class="flex-sb flex-w">
                <div class="card-btn" @click="menuClick(22)">
                    <img class="mr-12" src="@/assets/diy/batch-attribute.png" />
                    <div>批次属性</div>
                </div>
                <div class="card-btn" @click="menuClick(23)">
                    <img class="mr-12" src="@/assets/diy/report.png" />
                    <div>质检报告</div>
                </div>
                <div class="card-btn" @click="menuClick(24)">
                    <img class="mr-12" src="@/assets/diy/monitor.png" />
                    <div>监测数据</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        diy_id: {
            type: String,
            default: "0",
        },
        formData: {
            type: Array,
            default: [],
        },
        popData: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {
            admin_id: "",
        };
    },
    created() {
        this.admin_id = localStorage.getItem("admin_id");
    },
    methods: {
        getPop() {
            var value;
            value = this.formData.some((item) => item.type == 21);
            if (!value) {
                this.formData.splice(1, 0, this.popData);
            }
        },
        // 左侧菜单点击
        menuClick(e) {
            switch (e) {
                // -1：搜索组件
                // 0：背景设置
                case 1:
                    this.formData.push({
                        type: 1,
                        name: "图文导航",
                        content: {
                            version: 1, //版本号 - 兼容新老版本
                            type_id: 1, //导航样式
                            title_color: "#000",
                            text_color: "#999",
                            iconList: [
                                {
                                    value: "/icon/diys/smail.png",
                                    picview: "https://suyuan.hulianzaowu.com/icon/diys/smail.png",
                                    title: "标题",
                                    describe: "功能描述",
                                    action_id: 1,
                                    link_id: 1,
                                    link_name: "",
                                    imgList: [{ value: '', picview: "" }],
                                    clerk: '文案标题',
                                    clerk_value: 0,
                                },
                                {
                                    value: "/icon/diys/smail.png",
                                    picview: "https://suyuan.hulianzaowu.com/icon/diys/smail.png",
                                    title: "标题",
                                    describe: "功能描述",
                                    action_id: 1,
                                    link_id: 1,
                                    link_name: "",
                                    imgList: [{ value: '', picview: "" }],
                                    clerk: '文案标题',
                                    clerk_value: 0,
                                },
                                {
                                    value: "/icon/diys/smail.png",
                                    picview: "https://suyuan.hulianzaowu.com/icon/diys/smail.png",
                                    title: "标题",
                                    describe: "功能描述",
                                    action_id: 1,
                                    link_id: 1,
                                    link_name: "",
                                    imgList: [{ value: '', picview: "" }],
                                    clerk: '文案标题',
                                    clerk_value: 0,
                                },
                            ],
                            type_value: '1',
                            txt_size: '12',
                            txt_color_active: '#000',
                            txt_color: '#000',
                            active_img: { value: "", picview: "" },
                            nav_img: { value: "", picview: "" },
                            clerk_color: '#000',
                            clerk_size: '12',
                            bg_color: "#fff",
                            bg_value: 0,
                            bg_img: { value: "", picview: "" },
                            marginData: { top: 0, left: 0 },
                            paddingData: { top: 12, left: 12 },
                            radiusData: { top: 0, bottom: 0 },
                        },
                    });
                    break;
                case 2:
                    this.formData.push({
                        type: 2,
                        name: "轮播广告",
                        content: {
                            version: 1,
                            autoplay: "1",
                            time: "3",
                            height: "148.8",
                            bannerList: [
                                {
                                    value: "",
                                    picview: "https://suyuan.hulianzaowu.com/icon/diys/banner.png",
                                    action_id: 1,
                                    link_id: 1,
                                    link_name: "",
                                },
                            ],
                            marginData: { top: 0, left: 0 },
                            radiusData: { top: 0, bottom: 0 },
                        },
                    });
                    break;
                case 3:
                    this.formData.push({
                        type: 3,
                        name: "公告",
                        content: {
                            version: 1,
                            text: "文字展示文字展示文字展示",
                            size: "15",
                            text_color: "#000",
                            rollValue: 0,
                            rollSpeed: 100,
                            imgs: {
                                value: "/icon/diys/notice.png",
                                picview: "https://suyuan.hulianzaowu.com/icon/diys/notice.png",
                            },
                            bg_color: "#fff",
                            bg_value: 0,
                            bg_img: { value: "", picview: "" },
                            marginData: { top: 0, left: 0 },
                            paddingData: { top: 12, left: 12 },
                            radiusData: { top: 0, bottom: 0 },
                        },
                    });
                    break;
                case 4:
                    this.formData.push({
                        type: 4,
                        name: "标题",
                        content: {
                            version: 1,
                            style_value: "2", //标题样式
                            text: "标题",
                            size: "18",
                            position: "left",
                            text_color: "#000",
                            dec_color: "#FF761D",
                            bg_color: "#fff",
                            bg_value: 0,
                            bg_img: { value: "", picview: "" },
                            marginData: { top: 0, left: 0 },
                            paddingData: { top: 12, left: 12 },
                            radiusData: { top: 0, bottom: 0 },
                        },
                    });
                    break;
                case 5:
                    this.formData.push({
                        type: 5,
                        name: "图片广告",
                        content: {
                            version: 1,
                            style_id: 0, //图片样式id
                            imgList: [{ value: "", picview: "" }],
                            hotspot: [],
                            marginData: { top: 0, left: 0 },
                            radiusData: { top: 0, bottom: 0 },
                            preview_value: 1,
                        },
                    });
                    break;
                case 6:
                    this.formData.push({
                        type: 6,
                        name: "视频",
                        content: {
                            version: 1,
                            height: "148.8",
                            autoplay: "1", //播放方式
                            loop: 1, //循环播放
                            videoList: {
                                value: "/unidoc/zh/2minute-demo.mp4",
                                picview: "https://qiniu-web-assets.dcloud.net.cn/unidoc/zh/2minute-demo.mp4",
                            },
                            marginData: { top: 0, left: 0 },
                            radiusData: { top: 0, bottom: 0 },
                        },
                    });
                    break;
                case 7:
                    this.formData.push({
                        type: 7,
                        name: "文章列表",
                        content: {
                            version: 1,
                            style_value: "1", //标题样式
                            title: "大标题",
                            size: "20",
                            big_title_color: "#FF5000",
                            title_border_color: "#ccc",
                            title_color: "#FF5000",
                            title_bg_color: "#fff",
                            text: "文章内容",
                            text_color: "#000",
                            time_value: 1,
                            time_color: "#999",
                            dec_color: "#FF761D",
                            btn_value: 1,
                            btn_color: "#fff",
                            border_color: "#FF761D",
                            btn_text_color: "#FF761D",
                            mask_color: "#FFF8F4",
                            articleData: {
                                content: "文章内容",
                                title: "文章标题",
                                created_at: "2022-02-02",
                            },
                            bg_color: "#fff",
                            bg_value: 0,
                            bg_img: { value: "", picview: "" },
                            marginData: { top: 0, left: 0 },
                            paddingData: { top: 12, left: 12 },
                            radiusData: { top: 0, bottom: 0 },
                        },
                        articleData: [
                            {
                                id: "",
                                content: "文章内容",
                                title: "文章标题",
                                created_at: "2022-02-02",
                            },
                        ],
                    });
                    break;
                case 8:
                    this.formData.push({
                        type: 8,
                        name: "图文详情",
                        content: {
                            version: 1,
                            text: "图文详情",
                            btn_value: 1,
                            btn_color: "#fff",
                            border_color: "#FF761D",
                            btn_text_color: "#FF761D",
                            mask_color: "#FFF8F4",
                            bg_color: "#fff",
                            bg_value: 0,
                            bg_img: { value: "", picview: "" },
                            marginData: { top: 0, left: 0 },
                            paddingData: { top: 12, left: 12 },
                            radiusData: { top: 0, bottom: 0 },
                        },
                    });
                    break;
                case 9:
                    this.formData.push({
                        type: 9,
                        name: "营业执照",
                        content: {
                            version: 1,
                            marginData: { top: 0, left: 0 },
                            radiusData: { top: 0, bottom: 0 },
                        },
                    });
                    break;
                case 10:
                    this.formData.push({
                        type: 10,
                        name: "其他资质",
                        content: {
                            version: 1,
                            style_id: 0,
                            autoplay: "0",
                            indicator_color: "#fff",
                            imgList: [{ value: "", picview: "" }],
                            marginData: { top: 0, left: 0 },
                            radiusData: { top: 0, bottom: 0 },
                        },
                    });
                    break;
                case 11:
                    this.formData.push({
                        type: 11,
                        name: "公司图片",
                        content: {
                            version: 1,
                            style_id: 0,
                            autoplay: "0",
                            indicator_color: "#fff",
                            imgList: [{ value: "", picview: "" }],
                            marginData: { top: 0, left: 0 },
                            radiusData: { top: 0, bottom: 0 },
                        },
                    });
                    break;
                case 12:
                    this.formData.push({
                        type: 12,
                        name: "公司信息",
                        content: {
                            version: 1,
                            title_color: "#FF5000",
                            title_size: "20",
                            title_bg_color: "#fff",
                            title_border_color: "#ccc",
                            text_color: "#999",
                            txt_color: "#000",
                            size: "15",
                            bg_color: "#fff",
                            bg_value: 0,
                            bg_img: { value: "", picview: "" },
                            marginData: { top: 0, left: 0 },
                            paddingData: { top: 12, left: 12 },
                            radiusData: { top: 0, bottom: 0 },
                        },
                    });
                    break;
                case 13:
                    this.formData.push({
                        type: 13,
                        name: "产品属性",
                        // 生成4-5位随机数 (1000 到 99999)
                        key: this.admin_id + "a" + Date.now(),
                        content: {
                            version: 1,
                            style_value: "1", //标题样式
                            position: "left",
                            dec_color: "#FF761D",
                            title: "产品属性",
                            title_size: "20",
                            title_color: "#FF5000",
                            title_border_color: "#ccc",
                            title_bg_color: "#fff",
                            text_size: "15",
                            text_color: "#999",
                            txt_size: "15",
                            txt_color: "#000",
                            attributeData: [ { attribute_id: "", attribute_name: "", attribute_content: [] } ],
                            bg_color: "#fff",
                            bg_value: 0,
                            bg_img: { value: "", picview: "" },
                            marginData: { top: 0, left: 0 },
                            paddingData: { top: 12, left: 12 },
                            radiusData: { top: 0, bottom: 0 },
                            border_color: "#434343",
                        },
                    });
                    break;
                case 14:
                    this.formData.push({
                        type: 14,
                        name: "产品样册",
                        content: {
                            version: 1,
                            style_value: "1", //标题样式
                            style_id: 0, //图片样式
                            title: "产品样册",
                            position: "left",
                            dec_color: "#FF761D",
                            title_size: "20",
                            title_color: "#FF5000",
                            title_border_color: "#ccc",
                            title_bg_color: "#fff",
                            text_size: "18",
                            text_color: "#FF5000",
                            btn_value: 1,
                            btn_color: "#fff",
                            border_color: "#FF761D",
                            btn_text_color: "#FF761D",
                            mask_color: "#FFF8F4",
                            imgList: [{ value: "", picview: "" }],
                            bg_color: "#fff",
                            bg_value: 0,
                            bg_img: { value: "", picview: "" },
                            marginData: { top: 0, left: 0 },
                            paddingData: { top: 12, left: 12 },
                            radiusData: { top: 0, bottom: 0 },
                        },
                    });
                    break;
                case 15:
                    this.formData.push({
                        type: 15,
                        name: "产品质检报告",
                        content: {
                            version: 1,
                            style_value: "1", //标题样式
                            position: "left",
                            dec_color: "#FF761D",
                            style_set: "1", //样式设置
                            style_id: 0, //平铺样式
                            autoplay: "1",
                            time: "3",
                            imgList: [{ value: "", picview: "" }],
                            title: "报告标题",
                            title_size: "20",
                            title_color: "#FF5000",
                            title_border_color: "#ccc",
                            title_bg_color: "#fff",
                            text_color: "#FF5000",
                            text_size: "18",
                            bg_color: "#fff",
                            bg_value: 0,
                            bg_img: { value: "", picview: "" },
                            marginData: { top: 0, left: 0 },
                            paddingData: { top: 12, left: 12 },
                            radiusData: { top: 0, bottom: 0 },
                        },
                    });
                    break;
                case 16:
                    this.formData.push({
                        type: 16,
                        name: "实例节点",
                        content: {
                            version: 1,
                            style_value: "1", //标题样式
                            position: "left",
                            dec_color: "#FF761D",
                            title: "产品节点",
                            title_size: "20",
                            title_color: "#FF5000",
                            title_border_color: "#ccc",
                            title_bg_color: "#fff",
                            mould_size: "18",
                            mould_color: "#000",
                            text_size: "15",
                            text_color: "#FF5000",
                            txt_size: "12",
                            txt_color: "#000",
                            mode_id: "1",
                            line_color: "#D0D5EE",
                            circle_color: "#FF761D",
                            btn_value: 1,
                            btn_color: "#fff",
                            border_color: "#FF761D",
                            btn_text_color: "#FF761D",
                            mask_color: "#FFF8F4",
                            bg_color: "#fff",
                            bg_value: 0,
                            bg_img: { value: "", picview: "" },
                            mode_img: { value: "", picview: "" },
                            marginData: { top: 0, left: 0 },
                            paddingData: { top: 12, left: 12 },
                            radiusData: { top: 0, bottom: 0 },
                        },
                    });
                    break;
                case 17:
                    // 设置查询结果组件只push一次
                    var value;
                    value = this.formData.some((item) => item.type == 17);
                    if (value) {
                        return;
                    }
                    this.formData.push({
                        type: 17,
                        name: "查询结果",
                        content: {
                            version: 1,
                            style_value: "1", //标题样式
                            position: "left",
                            dec_color: "#FF761D",
                            title: "查询结果",
                            title_size: "20",
                            title_color: "#FF5000",
                            title_border_color: "#ccc",
                            title_bg_color: "#fff",
                            text_size: "15",
                            text_color: "#000000",
                            bg_color: "#fff",
                            bg_value: 0,
                            bg_img: { value: "", picview: "" },
                            marginData: { top: 0, left: 0 },
                            paddingData: { top: 12, left: 12 },
                            radiusData: { top: 0, bottom: 0 },
                        },
                    });
                    break;
                case 18:
                    this.formData.push({
                        type: 18,
                        name: "产品信息",
                        content: {
                            version: 1,
                            style_value: "1", //标题样式
                            img_value: "1", //产品图片
                            position: "left",
                            dec_color: "#FF761D",
                            title: "产品信息",
                            title_size: "20",
                            title_color: "#FF5000",
                            title_border_color: "#ccc",
                            title_bg_color: "#fff",
                            text_color: "#999",
                            text_size: "15",
                            txt_color: "#000",
                            txt_size: "15",
                            value1: 1,
                            value2: 1,
                            value3: 1,
                            value4: 1,
                            value5: 1,
                            value6: 1,
                            bg_color: "#fff",
                            bg_value: 0,
                            bg_img: { value: "", picview: "" },
                            marginData: { top: 0, left: 0 },
                            paddingData: { top: 12, left: 12 },
                            radiusData: { top: 0, bottom: 0 },
                        },
                    });
                    break;
                case 19:
                    this.formData.push({
                        type: 19,
                        name: "产品图片",
                        content: {
                            version: 1,
                            style_set: "1", //样式设置
                            style_id: 0, //平铺样式
                            autoplay: "1",
                            time: "3",
                            imgList: [{ value: "", picview: "" }],
                            marginData: { top: 0, left: 0 },
                            radiusData: { top: 0, bottom: 0 },
                        },
                    });
                    break;
                case 20:
                    this.formData.push({
                        type: 20,
                        name: "代理商信息",
                        content: {
                            version: 1,
                            style_value: "1", //标题样式
                            dec_color: "#FF761D",
                            position: "left",
                            title_size: "20",
                            title_color: "#FF5000",
                            title_border_color: "#ccc",
                            title_bc: "#fff",
                            type: ["授权编号", "手机号码", "负责区域"],
                            text_color: "#999",
                            txt_color: "#000",
                            size: "15",
                            bg_color: "#fff",
                            bg_value: 0,
                            bg_img: { value: "", picview: "" },
                            marginData: { top: 0, left: 0 },
                            paddingData: { top: 12, left: 12 },
                            radiusData: { top: 0, bottom: 0 },
                        },
                    });
                    break;
                // 21：弹窗组件
                case 22:
                    this.formData.push({
                        type: 22,
                        name: "批次属性",
                        content: {
                            version: 1,
                            style_value: "1", //标题样式
                            position: "left",
                            dec_color: "#FF761D",
                            headline: "批次属性",
                            headline_size: "20",
                            headline_color: "#FF5000",
                            headline_border_color: "#ccc",
                            headline_bg_color: "#fff",
                            headline_position: "left",
                            title_color: "#FF5000",
                            title_size: "18",
                            text_name_color: "#999",
                            text_name_size: "15",
                            text_color: "#000",
                            text_size: "15",
                            btn_value: 1,
                            btn_color: "#fff",
                            border_color: "#FF761D",
                            btn_text_color: "#FF761D",
                            mask_color: "#FFF8F4",
                            bg_color: "#fff",
                            bg_value: 0,
                            bg_img: { value: "", picview: "" },
                            marginData: { top: 0, left: 0 },
                            paddingData: { top: 12, left: 12 },
                            radiusData: { top: 0, bottom: 0 },
                        },
                    });
                    break;
                case 23:
                    this.formData.push({
                        type: 23,
                        name: "批次质检报告",
                        content: {
                            version: 1,
                            style_value: "1", //标题样式
                            position: "left",
                            dec_color: "#FF761D",
                            style_set: "1", //样式设置
                            style_id: 0, //平铺样式
                            autoplay: "1",
                            time: "3",
                            imgList: [{ value: "", picview: "" }],
                            title: "报告标题",
                            title_size: "20",
                            title_color: "#FF5000",
                            title_border_color: "#ccc",
                            title_bg_color: "#fff",
                            text_color: "#FF5000",
                            text_size: "18",
                            bg_color: "#fff",
                            bg_value: 0,
                            bg_img: { value: "", picview: "" },
                            marginData: { top: 0, left: 0 },
                            paddingData: { top: 12, left: 12 },
                            radiusData: { top: 0, bottom: 0 },
                        },
                    });
                    break;
                case 24:
                    this.formData.push({
                        type: 24,
                        name: "监测数据",
                        content: {
                            version: 1,
                            style_value: "1",
                            menuList: [
                                {
                                    title: "菜单名称",
                                    text: {name: "检测名称", txt: "数据", norm: "参考标准"},
                                    remark: "标准参考值: ≥0%",
                                },
                            ],
                            title_size: '18',
                            title_color_active: '#fff',
                            title_bg_color_active: '#3D3D3D',
                            title_color: '#555555',
                            title_bg_color: '#DCDCDC',
                            remark_color: '#676767',
                            other_color: '#6e6e6e',
                            name_size: '14',
                            name_color: '#333',
                            txt_size: '18',
                            txt_color: '#434343',
                            norm_size: '14',
                            norm_color: '#ccc',
                            border_color: "#ccc",
                            bg_color: "#DCDCDC",
                            bg_value: 0,
                            bg_img: { value: "", picview: "" },
                            marginData: { top: 0, left: 0 },
                            paddingData: { top: 12, left: 12 },
                            radiusData: { top: 0, bottom: 0 },
                        },
                    });
                    break;
                default:
                    console.log("DIY");
                    break;
            }
        },
    },
};
</script>

<style scoped>
.card {
    padding: 24px;
    margin-bottom: 12px;
    width: 100%;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
}
.title {
    margin-right: 50px;
    font-weight: 400;
    font-size: 16px;
    color: #484e66;
}
.flex-w {
    flex-wrap: wrap;
}
.card-btn {
    padding-left: 12px;
    margin: 6px 0;
    width: 130px;
    height: 42px;
    background: #ffffff;
    border: 1px solid #dce5eb;
    border-radius: 3px;
    display: flex;
    align-items: center;
    cursor: pointer;
}
</style>